// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__qf\\+Dt {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%); }

.styles_contentWrapper__IQn2Z {
  width: 100%;
  max-width: 45rem;
  padding: 2rem; }

.styles_successCard__3WHEc {
  border: 1px solid #8080802e;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  border-radius: 1rem;
  background: white; }

.styles_successContent__8MNDM {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3rem 2.5rem;
  gap: 2rem;
  text-align: center; }
  @media (max-width: 768px) {
    .styles_successContent__8MNDM {
      padding: 2rem 1.5rem;
      gap: 1.5rem; } }

.styles_iconWrapper__B78Os {
  margin-bottom: 0.5rem; }

.styles_successIcon__w8L5U {
  font-size: 5rem;
  animation: styles_celebrate__et\\+yB 1s ease-in-out; }

@keyframes styles_celebrate__et\\+yB {
  0% {
    transform: scale(0) rotate(0deg);
    opacity: 0; }
  50% {
    transform: scale(1.2) rotate(180deg); }
  100% {
    transform: scale(1) rotate(360deg);
    opacity: 1; } }

.styles_successTitle__NBurm {
  font-size: 2rem;
  color: #808080e6;
  margin: 0;
  font-weight: 700; }
  @media (max-width: 768px) {
    .styles_successTitle__NBurm {
      font-size: 1.5rem; } }

.styles_mainText__RJpXB {
  font-size: 1.15rem;
  line-height: 1.7;
  color: #808080b8;
  max-width: 90%;
  margin: 0; }

.styles_nextSteps__nNqnB {
  width: 100%;
  background: #80808012;
  padding: 2rem;
  border-radius: 0.75rem;
  text-align: left; }

.styles_nextStepsTitle__gVrnn {
  font-size: 1.1rem;
  color: #808080e6;
  margin-bottom: 1.25rem;
  text-align: center; }

.styles_stepsList__sxZZF {
  display: flex;
  flex-direction: column;
  gap: 1rem; }

.styles_stepItem__fBsmP {
  display: flex;
  align-items: center;
  gap: 1rem; }

.styles_stepIcon__PN03s {
  color: #10b981;
  font-size: 1.25rem;
  font-weight: bold;
  flex-shrink: 0; }

.styles_stepText__Bbvxn {
  font-size: 1rem;
  color: #808080b8;
  line-height: 1.5;
  margin: 0; }

.styles_encouragementText__iQzqr {
  font-size: 1rem;
  line-height: 1.7;
  color: #8080808a;
  font-style: italic;
  max-width: 85%;
  margin: 0;
  padding-top: 0.5rem; }

.styles_buttonGroup__tKMT4 {
  display: flex;
  gap: 1rem;
  width: 100%;
  max-width: 28rem;
  margin-top: 1rem; }
  @media (max-width: 768px) {
    .styles_buttonGroup__tKMT4 {
      flex-direction: column; } }

.styles_homeButton__0W56k {
  flex: 1 1;
  padding: 1rem 2rem;
  font-size: 1rem;
  font-weight: 600;
  min-height: 3rem; }

.styles_membershipButton__7yAt0 {
  flex: 1 1;
  padding: 1rem 2rem;
  font-size: 1rem;
  font-weight: 600;
  min-height: 3rem;
  border: 1px solid #8080805c; }
`, "",{"version":3,"sources":["webpack://./src/modules/membership/components/screens/membership-registration-success/styles.module.scss","webpack://./src/modules/Core/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,6DAA6D,EAAA;;AAG/D;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa,EAAA;;AAGf;EACE,2BCJgB;EDKhB,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB,EAAA;;AAGnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;EACT,kBAAkB,EAAA;EAElB;IARF;MASI,oBAAoB;MACpB,WAAW,EAAA,EAEd;;AAED;EACE,qBAAqB,EAAA;;AAGvB;EACE,eAAe;EACf,kDAAmC,EAAA;;AAGrC;EACE;IACE,gCAAgC;IAChC,UAAU,EAAA;EAEZ;IACE,oCAAoC,EAAA;EAEtC;IACE,kCAAkC;IAClC,UAAU,EAAA,EAAA;;AAId;EACE,eAAe;EACf,gBC5CgB;ED6ChB,SAAS;EACT,gBAAgB,EAAA;EAEhB;IANF;MAOI,iBAAiB,EAAA,EAEpB;;AAED;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBCzDgB;ED0DhB,cAAc;EACd,SAAS,EAAA;;AAGX;EACE,WAAW;EACX,qBCtEe;EDuEf,aAAa;EACb,sBAAsB;EACtB,gBAAgB,EAAA;;AAGlB;EACE,iBAAiB;EACjB,gBCvEgB;EDwEhB,sBAAsB;EACtB,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA;;AAGX;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAA;;AAGX;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,cAAc,EAAA;;AAGhB;EACE,eAAe;EACf,gBClGgB;EDmGhB,gBAAgB;EAChB,SAAS,EAAA;;AAGX;EACE,eAAe;EACf,gBAAgB;EAChB,gBC3GgB;ED4GhB,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,gBAAgB,EAAA;EAEhB;IAPF;MAQI,sBAAsB,EAAA,EAEzB;;AAED;EACE,SAAO;EACP,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB,EAAA;;AAGlB;EACE,SAAO;EACP,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,2BC9IgB,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n.container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n}\n\n.contentWrapper {\n  width: 100%;\n  max-width: 45rem;\n  padding: 2rem;\n}\n\n.successCard {\n  border: 1px solid $grey18;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);\n  border-radius: 1rem;\n  background: white;\n}\n\n.successContent {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 3rem 2.5rem;\n  gap: 2rem;\n  text-align: center;\n\n  @media (max-width: 768px) {\n    padding: 2rem 1.5rem;\n    gap: 1.5rem;\n  }\n}\n\n.iconWrapper {\n  margin-bottom: 0.5rem;\n}\n\n.successIcon {\n  font-size: 5rem;\n  animation: celebrate 1s ease-in-out;\n}\n\n@keyframes celebrate {\n  0% {\n    transform: scale(0) rotate(0deg);\n    opacity: 0;\n  }\n  50% {\n    transform: scale(1.2) rotate(180deg);\n  }\n  100% {\n    transform: scale(1) rotate(360deg);\n    opacity: 1;\n  }\n}\n\n.successTitle {\n  font-size: 2rem;\n  color: $grey90;\n  margin: 0;\n  font-weight: 700;\n\n  @media (max-width: 768px) {\n    font-size: 1.5rem;\n  }\n}\n\n.mainText {\n  font-size: 1.15rem;\n  line-height: 1.7;\n  color: $grey72;\n  max-width: 90%;\n  margin: 0;\n}\n\n.nextSteps {\n  width: 100%;\n  background: $grey7;\n  padding: 2rem;\n  border-radius: 0.75rem;\n  text-align: left;\n}\n\n.nextStepsTitle {\n  font-size: 1.1rem;\n  color: $grey90;\n  margin-bottom: 1.25rem;\n  text-align: center;\n}\n\n.stepsList {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.stepItem {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.stepIcon {\n  color: #10b981;\n  font-size: 1.25rem;\n  font-weight: bold;\n  flex-shrink: 0;\n}\n\n.stepText {\n  font-size: 1rem;\n  color: $grey72;\n  line-height: 1.5;\n  margin: 0;\n}\n\n.encouragementText {\n  font-size: 1rem;\n  line-height: 1.7;\n  color: $grey54;\n  font-style: italic;\n  max-width: 85%;\n  margin: 0;\n  padding-top: 0.5rem;\n}\n\n.buttonGroup {\n  display: flex;\n  gap: 1rem;\n  width: 100%;\n  max-width: 28rem;\n  margin-top: 1rem;\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n  }\n}\n\n.homeButton {\n  flex: 1;\n  padding: 1rem 2rem;\n  font-size: 1rem;\n  font-weight: 600;\n  min-height: 3rem;\n}\n\n.membershipButton {\n  flex: 1;\n  padding: 1rem 2rem;\n  font-size: 1rem;\n  font-weight: 600;\n  min-height: 3rem;\n  border: 1px solid $grey36;\n}\n","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__qf+Dt`,
	"contentWrapper": `styles_contentWrapper__IQn2Z`,
	"successCard": `styles_successCard__3WHEc`,
	"successContent": `styles_successContent__8MNDM`,
	"iconWrapper": `styles_iconWrapper__B78Os`,
	"successIcon": `styles_successIcon__w8L5U`,
	"celebrate": `styles_celebrate__et+yB`,
	"successTitle": `styles_successTitle__NBurm`,
	"mainText": `styles_mainText__RJpXB`,
	"nextSteps": `styles_nextSteps__nNqnB`,
	"nextStepsTitle": `styles_nextStepsTitle__gVrnn`,
	"stepsList": `styles_stepsList__sxZZF`,
	"stepItem": `styles_stepItem__fBsmP`,
	"stepIcon": `styles_stepIcon__PN03s`,
	"stepText": `styles_stepText__Bbvxn`,
	"encouragementText": `styles_encouragementText__iQzqr`,
	"buttonGroup": `styles_buttonGroup__tKMT4`,
	"homeButton": `styles_homeButton__0W56k`,
	"membershipButton": `styles_membershipButton__7yAt0`
};
export default ___CSS_LOADER_EXPORT___;
